
import {  defineComponent, onMounted, ref } from 'vue';
import DocumentCard from '@/components/DocumentCard.vue';
import { IQuiz } from '@/types/quiz';
import { routeContractorsItem } from '@/core/constants';
import { useRouter } from 'vue-router';
import { CtaType } from '@/types/CtaType';

export default defineComponent({
  name: 'ContractorsCompanyPage',
  components: {
    DocumentCard
  },
  setup() {
    const documents = ref<IQuiz[]>([]);
    const router = useRouter();


    onMounted(() => {
      const payload = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
      const data = payload.map(id => ({
        id: id,
        name: `Company ${id}`,
        color: 1,
        cta_type: CtaType.EMS,
        answers_progress: `${Math.floor(Math.random() * 100) + 1}`,
        created_at: new Date(),
        updated_at: new Date(),
        archived_at: null,
        filter_values: [],
        is_update_pending: false,
        validation_errors: []
      }));
      documents.value = data;
    });



    const businessFunctionId = ref(-1);

    const goToQuizEdit = (quizId: number) => { //@todo should be refactored
      router.push({
        name: routeContractorsItem,
        params: {
          id: quizId
        }
      });
    };

    return {
      documents,
      goToQuizEdit,
      businessFunctionId,
    };
  },
});
